import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer';
import './styles/HomePage.css';
import welcomeVideo from '../../media/kihivas.mp4';
import GoogleReviewsCarousel from '../GoogleReviewsCarousel';
import HeroGallerySlider from '../HeroGallerySlider';
import NaptarHeroCardPreview from '../NaptarHeroCardPreview';
import EtelapHeroCardPreview from '../EtelapHeroCardPreview';
import VirtualisSetaHeroCardPreview from '../VirtualisSetaHeroCardPreview';
import DailyLifeCarousel from '../homepage/DailyLifeCarousel';
import HomeStatsStrip from '../homepage/HomeStatsStrip';
import DayTimelineSection from '../homepage/DayTimelineSection';
import FeaturedProgramsSection from '../homepage/FeaturedProgramsSection';

const HomePage = () => {
  const navigate = useNavigate();
  const [currentCard, setCurrentCard] = useState(0);

  const villaCards = [
    {
      id: 1,
      title: "Naptár",
      description: "Tekintse meg a havi programokat és eseményeket. Napi foglalkozások, kulturális programok és közösségi események.",
      image: "naptar",
      preview: "naptar",
      buttonText: "Programok Megtekintése",
      action: () => navigate('/naptar')
    },
    {
      id: 2,
      title: "Heti Étlap",
      description: "Aktuális és következő heti étlapok különböző diétás kategóriákban. Normál, diabetikus, pépes és egyéb speciális ételek.",
      image: "heti-etlap",
      preview: "etlap",
      buttonText: "Étlap Megtekintése",
      action: () => navigate('/heti-etlap')
    },
    {
      id: 3,
      title: "Virtuális Séta",
      image: "virtualis-seta",
      preview: "virtualis-seta",
      action: () => navigate('/virtualis-seta')
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCard((prev) => (prev + 1) % villaCards.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [villaCards.length]);

  const nextCard = () => {
    setCurrentCard((prev) => (prev + 1) % villaCards.length);
  };

  const prevCard = () => {
    setCurrentCard((prev) => (prev - 1 + villaCards.length) % villaCards.length);
  };

  const goToCard = (index) => {
    setCurrentCard(index);
  };

  return (
    <>
      <section id="home" className="hero">
        <HeroGallerySlider />

        <div className="hero-overlay"></div>
        
        <div className="hero-main-content">
          <div className="hero-left">
            <div className="hero-decorative-line"></div>
            <h1 className="hero-title">NAPVIRÁG<br/>IDŐSEK OTTHONA</h1>
            <p className="hero-subtitle">
              Nyugalom. Gondoskodás. Biztonság.
              <br />
              Több mint 20 éve az idősgondozásban.
            </p>
            <button
              type="button"
              className="cta-button"
              onClick={() => navigate('/elerhetosegek')}
            >
              TUDJON MEG TÖBBET <span className="arrow">→</span>
            </button>
            
            <div className="hero-dots top-dots"></div>
            <div className="hero-arrows bottom-arrows"></div>
          </div>
          
          <div className="hero-right">
            <div className="villa-carousel">
              <div className="carousel-container">
                <div className="carousel-track">
                  {villaCards.map((card, index) => {
                    let cardClass = 'villa-card carousel-card';
                    let customStyle = {};
                    
                    const prevIndex = (currentCard - 1 + villaCards.length) % villaCards.length;
                    const nextIndex = (currentCard + 1) % villaCards.length;
                    
                    if (index === currentCard) {
                      cardClass += ' active';
                    } else if (index === prevIndex) {
                      cardClass += ' prev';
                    } else if (index === nextIndex) {
                      cardClass += ' next';
                    } else {
                      cardClass += ' hidden';
                      
                      const distance = (index - currentCard + villaCards.length) % villaCards.length;
                      
                      if (distance === villaCards.length - 1) {
                        customStyle = {
                          transform: 'translateX(-352px) translateY(50px) scale(0.7) rotateY(45deg)',
                          opacity: 0,
                          transition: 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
                        };
                      } else if (distance === 2 || (villaCards.length === 3 && distance === 2)) {
                        customStyle = {
                          transform: 'translateX(308px) translateY(50px) scale(0.7) rotateY(-45deg)',
                          opacity: 0,
                          transition: 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
                        };
                      }
                    }
                    
                    return (
                      <div key={card.id} className={`${cardClass} ${card.image}`} style={customStyle}>
                        {card.preview === 'naptar' ? (
                          <NaptarHeroCardPreview onNavigate={card.action} />
                        ) : card.preview === 'etlap' ? (
                          <EtelapHeroCardPreview onNavigate={card.action} />
                        ) : card.preview === 'virtualis-seta' ? (
                          <VirtualisSetaHeroCardPreview onNavigate={card.action} />
                        ) : (
                          <>
                        <div className="card-image">
                          {card.imageSrc ? (
                            <img
                              src={card.imageSrc}
                              alt={card.title}
                              className="card-image-photo"
                              loading="lazy"
                              decoding="async"
                            />
                          ) : (
                            <div className={`image-placeholder ${card.image}`}>
                              <span>
                                {card.title.split(' ')[0]} {card.title.split(' ')[1]}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="card-content">
                          <h3>{card.title}</h3>
                          <p>{card.description}</p>
                          <button
                            type="button"
                            className="card-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              card.action();
                            }}
                          >
                            {card.buttonText} <span>→</span>
                          </button>
                        </div>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              
              <div className="carousel-controls">
                <button className="carousel-btn prev-btn" onClick={prevCard}>
                  <span>‹</span>
                </button>
                <button className="carousel-btn next-btn" onClick={nextCard}>
                  <span>›</span>
                </button>
              </div>
              
              <div className="carousel-indicators">
                {villaCards.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${index === currentCard ? 'active' : ''}`}
                    onClick={() => goToCard(index)}
                  />
                ))}
              </div>
            </div>
            
            <div className="hero-dots right-dots"></div>
            <div className="hero-arrows right-arrows"></div>
          </div>
        </div>
      </section>

      <section className="about-awards-section">
        <div className="container">
          <div className="about-awards-content">
            <div className="section-header">
              <h2 className="section-title">NAPVIRÁG IDŐSEK OTTHONA</h2>
              <p className="section-subtitle">
                Budakalászon, 2006 óta — személyes gondoskodás és közösségi élet
              </p>
            </div>

            <div className="about-text-content">
              <p className="about-description">
                A Napvirág Idősek Otthona <strong>123 akadálymentes, kényelmesen, otthonosan berendezhető, napfényes apartmant</strong> és 
                közös tereit kínálja lakóinak: étterem, könyvtár, tornaterem és orvosi rendelő. 
                Munkatársaink <strong>naponta 24 órában</strong> gondoskodnak, a mentálhigiénés 
                csapat <strong>hétköznapokon változatos programokat</strong> szervez — zenés délutánoktól 
                a kreatív foglalkozásokig.
              </p>
              
              <p className="about-location">
                Budakalász szívében, a Duna-part közelében élhetnek lakóink nyugodt, 
                otthonos környezetben. Célunk, hogy mindenki megtalálja a saját ritmusát: 
                részt vehet a közös programokon, vagy a saját apartmanában pihen — 
                ahogy éppen jól esik.
              </p>
            </div>

            <div className="landing-google-reviews">
              <GoogleReviewsCarousel />
            </div>
          </div>
        </div>
      </section>

      <section className="welcome-section">
        <div className="container">
          <div className="welcome-content">
            <div className="welcome-media">
              <div className="welcome-video-container">
                <video 
                  className="welcome-video" 
                  autoPlay 
                  muted 
                  loop 
                  playsInline
                  src={welcomeVideo}
                >
                  Your browser does not support the video tag.
                </video>
                <div className="video-overlay" onClick={() => {
                  const video = document.querySelector('.welcome-video');
                  if (video.requestFullscreen) {
                    video.requestFullscreen();
                  } else if (video.webkitRequestFullscreen) {
                    video.webkitRequestFullscreen();
                  } else if (video.msRequestFullscreen) {
                    video.msRequestFullscreen();
                  }
                }}>
                  <div className="play-button">
                    <span>▶</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="welcome-text">
              <div className="welcome-badge">ÜDVÖZÖLJÜK OTTHONUNKBAN</div>
              <h2 className="welcome-title">Így kell élni.</h2>
              <p className="welcome-description">
                A Napvirágban a mindennapok a közösségről, a programokról és nyugalomról szólnak. 
                Ismerje meg lakóink életét, nézze meg a heti programokat és étlapunkat — vagy vegye fel velünk a kapcsolatot, 
                ha kérdése van a beköltözéssel kapcsolatban!
              </p>
              <button
                type="button"
                className="download-brochure-btn"
                onClick={() => navigate('/elerhetosegek')}
              >
                Kapcsolatfelvétel
              </button>
            </div>
          </div>
        </div>
      </section>

      <DailyLifeCarousel />
      <HomeStatsStrip />
      <DayTimelineSection />
      <FeaturedProgramsSection />

      <Footer />
    </>
  );
};

export default HomePage;
